// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"aaa137b89575f6731ad0","293":"b7cc388518f6fb00a09d","518":"f7e92321f6332fd68ded","779":"a282948d9ae5916f449e"}[chunkId] + ".js";
};